if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.pack = this.form.dataset.pack;
      this.card = this.form.dataset.card;
      this.packMeals =
        this.card
          ? this.form.parentElement.parentElement.querySelector('product-info')
              ? this.form.parentElement.parentElement.querySelector('product-info').querySelectorAll('pack-meal-product')
              : false
          : this.form.closest('product-info')
              ? this.form.closest('product-info').querySelectorAll('pack-meal-product')
              : false

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      const isShippingAvailable = localStorage.getItem(window.localStorageKeys.validShippingStatus)

      const formData = new FormData(this.form);

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }

      if (Object.is(isShippingAvailable, null) || isShippingAvailable === 'false') {
        this.cart.open(evt.target)

        let customerTriedProduct = {}

        if (this.pack && this.packMeals.length) {
          const payload = {
            'items': []
          };
          this.packMeals.forEach(meal => {
            const id = meal.querySelector('.pack-variant-id').value
            const quantity = meal.querySelector('.pack-quantity').value
            payload['items'].push({
              'id': id,
              'quantity': quantity,
            });
          })
          customerTriedProduct = {
            id: payload,
            pack: true,
            sections: formData.get('sections'),
            sections_url: formData.get('sections_url'),
          }
        } else {
          customerTriedProduct = {
            id: formData.get('id'),
            pack: false,
            sections: formData.get('sections'),
            sections_url: formData.get('sections_url'),
          }
        }

        localStorage.setItem(window.localStorageKeys.customerTriedProduct, JSON.stringify(customerTriedProduct))

        const drawerInner = document.querySelector('.drawer__inner-empty');
        const drawerText = document.querySelector('.form__head p');

        drawerInner.style.opacity = '0';
        drawerInner.addEventListener("transitionend", function () {
          drawerInner.style.opacity = '1';
        });

        drawerText.style.opacity = '0';
        drawerText.addEventListener("transitionend", function () {
          drawerText.style.opacity = '1';
        });
      } else {
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        if (this.pack && this.packMeals.length) {
          const payload = {
            'items': []
          };
          this.packMeals.forEach(meal => {
            const id = meal.querySelector('.pack-variant-id').value
            const quantity = meal.querySelector('.pack-quantity').value
            payload['items'].push({
              'id': id,
              'quantity': quantity,
            });
          })

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          })
            .then(response => {
              return response.json();
            })
            .then(() => {
              if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
              this.error = false;

              fetch(window.location.pathname + "?sections=cart-drawer,cart-icon-bubble")
                .then(res => res.json())
                .then(res => {
                  this.cart.renderContents({
                    id: null,
                    sections: res,
                  });
                });
            })
            .catch((error) => {
              console.error('Error:', error);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            });
        } else {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          if (this.cart) {
            this.cart.setActiveElement(document.activeElement);
          }

          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener('modalClosed', () => {
                  setTimeout(() => { this.cart.renderContents(response) });
                }, { once: true });
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            });
        }
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
